/** @jsx jsx */
import React from 'react';

import { utilityColor } from 'components/styles';
import FormTitle from 'components/atoms/Form/FormTitle';
import FormField from 'components/atoms/Form/FormField';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import PrimaryButton from 'components/atoms/Button';
import RadioSelector from 'components/molecules/RadioSelector';
import FileSelectButton from 'components/molecules/FileSelectButton';
import BodyText from 'components/atoms/BodyText';

import { useHistory } from 'react-router-dom';
import ConfirmActionModal, { ActionType } from 'components/organismos/ConfirmActionModal';
import { useOrganizationCsvForm } from './hooks';
import { css, jsx } from '@emotion/core';
import BlockUI from 'components/molecules/BlockUi';
import LableTitle from 'components/atoms/LableTitle';

const style = {
  uploadFileCSV: css({
    height: '105px',
    width: '400px',
    border: '1px solid #dcdcdc',
    borderRadius: '2px',
    backgroundColor: '#f8f8f8',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  }, css`
  span {
    position: absolute;
    left: 95px;
  }
  button {
    margin-left: 35px;
  }
`),
  wrapUpload: css({
    maxWidth: '400px',
    margin: '30px auto',
  }),
  wrap: css({
    padding: '15px'
  }),
};

export type UploadType = '0' | '1' | '2';

const StaffCsvImportPage: React.FC = () => {
  const {
    confirmModalOpen, closeConfirmModal, uploadType, setUploadType,
    uploadTypeItems, uploadFile, setUploadFile, onSubmit, errors,blocking
  } = useOrganizationCsvForm();
  const history = useHistory();

  return (
    <BlockUI blocking={blocking}>
      <div css={style.wrap}>
        <LableTitle
          title="データ種別"
          customStyle={css({margin: '0px', paddingLeft:'0'})}
        />
        <FormField>
          <RadioSelector
            name="uploadType"
            items={uploadTypeItems}
            value={uploadType}
            setValue={(e) => setUploadType(e.target.value as UploadType)}
          />
        </FormField>
        <div css={style.wrapUpload}>
          <div css={style.uploadFileCSV}>
            <FileSelectButton
              text="CSVファイルをアップロード"
              ghost={true}
              setFile={setUploadFile}
              accept="text/csv,.csv,application/vnd.ms-excel"
            />
          </div>
          <BodyText color={utilityColor.error} size="sm">CSVファイルの1行目（ヘッダー行）はインポートされません。</BodyText>
          {
            uploadFile || errors
              ? (
                <FormField
                  displayBlock={true}
                >
                  <div>
                    {uploadFile?.name}
                  </div>
                  {errors && errors.map((error) => (
                    <div key={error}>
                      <BodyText color={utilityColor.error}>
                        {error}
                      </BodyText>
                    </div>
                  ))}
                </FormField>
              )
              : null
          }

          <FormSubmitArea customStyle={css({ margin: '30px auto', textAlign: 'center' })}>
            <div>
              <PrimaryButton
                text="インポート"
                onClick={onSubmit}
                disabled={!uploadFile}
              />
            </div>

            <PrimaryButton
              text="戻る"
              onClick={() => {
                history.goBack();
              }}
              ghost={true}
            />

          </FormSubmitArea>
        </div>
        <ConfirmActionModal
          open={confirmModalOpen}
          closeHandler={closeConfirmModal}
          onSubmit={onSubmit}
          actionType={ActionType.IMPORT}
        />
      </div>
    </BlockUI>
  );
};

export default StaffCsvImportPage;
